// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._y44v1rys{animation:var(--_mb5lf8)}._152tze3t{inset-block-start:var(--ds-space-0,0)}\n._16qs1wx8{box-shadow:0 0 0 2px var(--ds-border-discovery,#8270db)}\n._1bsb1osq{width:100%}\n._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}\n._4t3i1osq{height:100%}\n._kqswstnw{position:absolute}\n@media (prefers-reduced-motion:reduce){._1bumglyw{animation:none}._sedtglyw{transition:none}}", ""]);
// Exports
module.exports = exports;
